import { Flex, Popconfirm, Tooltip } from 'antd';
import { AuthorizedIcon } from '../../components';
import TrashSolidBlack from '../../assets/icons/trash-solid-b-black.svg';
import PenToSquareSolidBlack from '../../assets/icons/pen-to-square-solid-w-black.svg';
import FolderOpenRegular from '../../assets/icons/folder-open-regular.svg';
import styles from './index.module.scss';
import { ColumnType } from 'antd/es/table';
import { actionTypes } from '../../assets/enums';
import { IFile, IOrganization, IReconciliationDataSource } from '../../types';
import { IEnum } from '../../services/type';
import { formatCurrencyTRY } from '../../utils/functions';

export const getColumns = (
  handleOpenEditModal: (id: number) => void,
  handleClickDelete: (id: number) => Promise<void>,
  handleSetAdditionalFile: (id: number, file: IFile[]) => void,
  organizations: IOrganization[],
  currentAccounts: IEnum[],
): Array<ColumnType<IReconciliationDataSource> & { searchable?: boolean }> => [
  {
    title: 'Şirket',
    dataIndex: 'organization',
    key: 'organization',
    width: 125,
    searchable: true,
    filters: organizations.map((item) => ({
      text: item.name || '',
      value: item.id,
    })),
    sorter: (a, b) => a.organization - b.organization,
    render: (_, record) => (
      <Tooltip
        title={
          organizations.find((item) => item.id === record.organization)?.name
        }
      >
        <span>{`${organizations.find((item) => item.id === record.organization)?.name.slice(0, 15)}...`}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Cari Bilgiler',
    dataIndex: 'current_account',
    key: 'current_account',
    width: 120,
    sorter: (a, b) => a.current_account?.localeCompare(b.current_account),
    render: (_, record) => (
      <div>
        {
          currentAccounts.find((item) => item.key === record.current_account)
            ?.value
        }
      </div>
    ),
  },
  {
    title: 'Mutabakat Tarihi',
    dataIndex: 'reconciliation_date',
    key: 'reconciliation_date',
    width: 150,
    sorter: (a, b) =>
      a.reconciliation_date?.localeCompare(b.reconciliation_date),
  },
  {
    title: 'Toplam Borç',
    dataIndex: 'total_debt',
    key: 'total_debt',
    width: 130,
    sorter: (a, b) => a.total_debt - b.total_debt,
    render: (_, record) => (
      <div>
        {formatCurrencyTRY(record.total_debt)} {record.currency_label}
      </div>
    ),
  },
  {
    title: 'Vadesi Geçmiş',
    dataIndex: 'due_debt',
    key: 'due_debt',
    width: 120,
    sorter: (a, b) => a.due_debt - b.due_debt,
    render: (_, record) => (
      <div>
        {formatCurrencyTRY(record.due_debt)} {record.currency_label}
      </div>
    ),
  },
  {
    title: 'İşlem',
    dataIndex: 'action',
    key: 'action',
    width: 160,
    render: (_: unknown, record: IReconciliationDataSource) => (
      <Flex justify="flex-end" gap={14}>
        <Popconfirm
          title={
            <div className={styles.popconfirmTitle}>
              Silme işlemini onaylıyor musunuz?
            </div>
          }
          overlayInnerStyle={{
            width: 150,
            borderColor: '#D6222A',
            borderWidth: 1,
            borderStyle: 'solid',
          }}
          okText="Onayla"
          cancelText="İptal"
          icon={null}
          color="#FAFAFA"
          okButtonProps={{ danger: true, style: { width: '45%' } }}
          cancelButtonProps={{ danger: true, style: { width: '45%' } }}
          onConfirm={() => record.id && handleClickDelete(record.id)}
        >
          <AuthorizedIcon
            action="delete"
            model="reconciliation"
            popoverText={actionTypes.DELETE}
            source={TrashSolidBlack}
          />
        </Popconfirm>
        <AuthorizedIcon
          action="change"
          model="reconciliation"
          popoverText={actionTypes.CHANGE}
          source={PenToSquareSolidBlack}
          onClick={() => record?.id && handleOpenEditModal(record.id)}
        />
        <AuthorizedIcon
          action="view"
          model="reconciliationadditionalfile"
          popoverText={actionTypes.ADDITIONAL_FILE}
          source={FolderOpenRegular}
          onClick={() =>
            handleSetAdditionalFile(record?.id || 0, record.additional_files)
          }
        />
      </Flex>
    ),
  },
];
